class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  // getSearchResults(searchTerm) {
  //         fetch(`${routes.predictive_search_url}?q=${term}&${'resources[type]'}=product&${'resources[options][fields]'}=title,product_type,variants.title,vendor,variants.sku&${'resources[limit]'}=8&section_id=predictive-search`)
         
  //     .then((response) => {
  //       if (!response.ok) {
  //         var error = new Error(response.status);
  //         this.close();
  //         throw error;
  //       }

  //       return response.text();
  //     })
  //     .then((text) => {
  //       const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
  //       this.predictiveSearchResults.innerHTML = resultsMarkup;
  //       this.open();
  //     })
  //     .catch((error) => {
  //       this.close();
  //       throw error;
  //     });
  // }
  getSearchResults(searchTerm) {
  // Ensure the search term is properly encoded for URL
  const encodedSearchTerm = encodeURIComponent(searchTerm);

  // Create the fetch URL with dynamic searchTerm
  const fetchUrl = `${window.Shopify.routes.root}search/suggest?q=${encodedSearchTerm}&resources[type]=product,query,page,article&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku&section_id=predictive-search`;

  fetch(fetchUrl)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
    })
    .catch((error) => {
      this.close();
      console.error("Error fetching search results: ", error);
      // Optionally, handle error in UI (e.g., show a message)
    });
}


  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);